import { Breadcrumbs, type BreadcrumbsProps } from '@mui/material'
import type { FC } from 'react'
import { molsonUseTheme } from '@/theme/customMuiExports.ts'
import { MolsonIcon } from '../molson-icons'

export type MolsonBreadcrumbsProps = BreadcrumbsProps & {
  dataTestId?: string
  breadCrumbItems: Array<React.ReactNode>
  onClickHomeButton: React.MouseEventHandler
  withHomeIcon?: boolean
}

export const MolsonBreadcrumb: FC<MolsonBreadcrumbsProps> = ({
  dataTestId,
  breadCrumbItems,
  onClickHomeButton,
  withHomeIcon = true,
  ...props
}) => {
  const theme = molsonUseTheme()

  return (
    <Breadcrumbs
      separator={<MolsonIcon variant="CHEVRON_RIGHT" iconColor="ghost" />}
      aria-label="breadcrumb"
      data-testid={dataTestId}
      sx={{
        a: {
          color: theme.palette.secondary[700],
          fontSize: '0.875rem',
          fontWeight: '500',
          lineHeight: '20px',
          textDecoration: 'none'
        }
      }}
      {...props}
    >
      {withHomeIcon && (
        <MolsonIcon
          cursor="pointer"
          onClick={onClickHomeButton}
          customVariant="EQUIPMENT"
        />
      )}
      {breadCrumbItems}
    </Breadcrumbs>
  )
}
